import React from 'react';

class FieldError extends React.Component {
  render() {
    return (
      <span className="field-error">
        <i className="fas fa-exclamation-circle" />
        <span className="message">{this.props.message || 'error'}</span>
      </span>
    );
  }
}

export default FieldError;
